import { apiRequest, type Schemas } from "./client";

export type CorporateApplication = NonNullable<Schemas["CorporateApplicationRecord"]["data"]>;
export type DocumentKind = CorporateApplication["documents"][number]["kind"];

/** Applying for a corporate account (PRD 5.11). The newest application, or null. */
export const corporateApi = {
  get: () => apiRequest<Schemas["CorporateApplicationRecord"]>("/api/v1/corporate_application").then((r) => r.data),
  apply: (form: FormData) =>
    apiRequest<Schemas["CorporateApplicationRecord"]>("/api/v1/corporate_application", { method: "POST", body: form }).then((r) => r.data!),
};
